import gql from 'graphql-tag.macro';
import { get, map } from 'lodash';

const QUERY = gql`
  query getPaginatedPositions(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $filter: PositionFilter
    $ids: [ID!]
    $sort: PositionSort
  ) {
    paginatedPositions(
      first: $first
      last: $last
      after: $after
      before: $before
      filter: $filter
      ids: $ids
      sort: $sort
    ) {
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
      edges {
        node {
          id
          title
          lastUsedAt
          summary
          additionalDetails
          activeJrCount
          mdjCount
          updatedAt
          taskStatements {
            id
            task
          }
          badges {
            id
            name
            category
          }
          creator {
            id
            fullName
          }
          workContexts {
            id
            elementName
            group
          }
          dressCodeRequirements {
            id
            requirementGroup
            description
          }
          dressCodeEnvironments {
            employerDescription
            label
            id
          }
        }
      }
    }
  }
`;

const reducer = (payload) => {
  const positions = get(payload, 'paginatedPositions.edges', []);
  return {
    nodes: map(positions, ({ node }) => node),
    ...payload.paginatedPositions,
  };
};

export const paginatedPositions = {
  query: QUERY,
  paginated: true,
  reducer,
};

export default paginatedPositions;
